import React from "react";
import ReactDOM from "react-dom/client";

import { IUserInfoProps } from "./components/user-info/type";
import { ProfilePopover } from "./components/profile-popover";

class MicroUserInfoProfile {
  public containerId: string;
  public root?: ReactDOM.Root;
  constructor(containerId: string) {
    this.containerId = containerId;
  }

  detectHost() {
    // detect env
  }

  render(props: IUserInfoProps) {
    const host = document.getElementById(this.containerId) as HTMLElement;

    // const profileRef = (profile) => {
    //   if (!profile) return;
    //   host.appendChild(profile);
    // };
    if (!this.root) {
      this.root = ReactDOM.createRoot(host as unknown as HTMLElement);
    }
    this.root.render(<ProfilePopover {...props} />);
  }

  unmount() {
    if (!this.root) {
      console.warn(`root not found`);
      return;
    }
    this.root.unmount();
  }
}

export { MicroUserInfoProfile };
